import { ITmpSessionEvent } from "../../../@types/admin/AdminTmpIntegration";
import { getLongFormattedDate } from "../../../utils/dateFormatter";
import {
  Timeline,
  TimelineBody,
  TimelineDetail,
  TimelineDot,
  TimelineHeading,
  TimelineItem,
  TimelineMeta,
  TimelineNote,
  TimelineTitle,
} from "./AdminTmpIntegration.styles";
import {
  EVENT_SOURCE_LABELS,
  eventLabel,
  eventTone,
} from "./tmpSessionPresentation";

interface ITmpSessionTimelineProps {
  events: ITmpSessionEvent[];
}

/**
 * Every step a TMP order went through, oldest first (EN-5203): who caused it,
 * when, and the detail the API recorded (field names, ids, redacted errors).
 */
export function TmpSessionTimeline({ events }: ITmpSessionTimelineProps) {
  if (events.length === 0) {
    return <TimelineNote>No history recorded for this order.</TimelineNote>;
  }

  const reconstructed = events.some((e) => e.reconstructed);

  return (
    <>
      {reconstructed && (
        <TimelineNote data-testid="tmp-history-reconstructed">
          This order arrived before step history was recorded. Only its main
          milestones are shown.
        </TimelineNote>
      )}
      <Timeline data-testid="tmp-session-timeline">
        {events.map((event, index) => (
          <TimelineItem
            // eslint-disable-next-line react/no-array-index-key
            key={`${event.kind}-${event.occurredAt}-${index}`}
          >
            <TimelineDot tone={eventTone(event.kind)} aria-hidden />
            <TimelineBody>
              <TimelineHeading>
                <TimelineTitle>{eventLabel(event)}</TimelineTitle>
                <TimelineMeta>
                  {getLongFormattedDate(event.occurredAt, "—")} ·{" "}
                  {EVENT_SOURCE_LABELS[event.source] ?? event.source}
                </TimelineMeta>
              </TimelineHeading>
              {event.detail && <TimelineDetail>{event.detail}</TimelineDetail>}
            </TimelineBody>
          </TimelineItem>
        ))}
      </Timeline>
    </>
  );
}
